/* @flow */

export default class AddCompanyBankAccountRequest {
  companyId: number;
  bankCountryId: number;
  bankIdentifier: string;
  bankAccount: string;
  isMain: boolean;
}
